module.exports = __webpack_public_path__ + "static/media/Picture.713ef736.png";